import type { CityConfig } from "../city-template/types";

export const clevelandConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Ohio Department of Health", href: "https://odh.ohio.gov/know-our-programs/vital-statistics", description: "Official Ohio vital records office in Columbus" },
    { label: "Marriage Licenses — Cuyahoga County Probate Court", href: "https://cuyahogacounty.gov/probate", description: "Cuyahoga County Probate Judge — marriage license issuance" },
    { label: "Divorce Records — Cuyahoga County Clerk of Courts", href: "https://cccourts.org/", description: "Cuyahoga County Clerk of Courts — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Ohio Department of Health for online vital record orders" },
  ],
  city: "Cleveland",
  state: "Ohio",
  stateAbbr: "OH",
  slug: "cleveland",
  route: "/cities/cleveland",
  title: "Emergency Passport Cleveland, OH — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Cleveland, OH — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Cuyahoga County and Northeast Ohio. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Cleveland, OH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Cleveland and Northeast Ohio travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Cleveland%20Ohio%20skyline%20at%20dusk%20with%20the%20iconic%20Rock%20and%20Roll%20Hall%20of%20Fame%20along%20Lake%20Erie%20waterfront%2C%20downtown%20skyscrapers%20reflecting%20warm%20amber%20light%20on%20the%20calm%20lake%20surface%2C%20dramatic%20clouds%20with%20golden%20sunset%20colors%2C%20city%20lights%20beginning%20to%20glow%2C%20professional%20cityscape%20photography%20wide%20panoramic%20view%2C%20vibrant%20great%20lake%20shoreline&width=1800&height=700&seq=cleveland-hero-oh-001&orientation=landscape",
  heroImageAlt: "Cleveland Ohio skyline at dusk with the Rock and Roll Hall of Fame along Lake Erie waterfront",
  geoPosition: "41.4993;-81.6944",
  geoPlacename: "Cleveland, Ohio",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 345 miles from Cleveland via I-80",
  },
  nearbyCitiesZips: [
    { name: "Cleveland", zips: "44101–44199" },
    { name: "Lakewood", zips: "44107" },
    { name: "Parma", zips: "44129, 44130, 44134" },
    { name: "Shaker Heights", zips: "44120, 44122" },
    { name: "Euclid", zips: "44117, 44123, 44132" },
    { name: "Brook Park", zips: "44142" },
    { name: "Westlake", zips: "44145" },
    { name: "North Olmsted", zips: "44070" },
    { name: "Strongsville", zips: "44136, 44149" },
    { name: "Solon", zips: "44139" },
    { name: "Mentor", zips: "44060, 44061" },
    { name: "Akron", zips: "44301–44399" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Cleveland departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-flight-takeoff-line", title: "Airport Proximity", desc: "Serving CLE and CAK travelers across Northeast Ohio" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Akron, OH", route: "/akron" },
    { name: "Fast passport renewal in Columbus, OH", route: "/columbus-oh" },
    { name: "Emergency passport help in Dayton, OH", route: "/dayton" },
    { name: "Urgent passport services in Mentor, OH", route: "/mentor" },
    { name: "Same-day passport help in Cuyahoga Falls", route: "/cuyahoga-falls" },
    { name: "Passport courier services in Strongsville", route: "/strongsville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Cleveland from our local office at 127 Public Square. Visit us by appointment, or use our courier pickup throughout Cuyahoga County and greater Northeast Ohio.",
  fpcOfficeDistance: "127 Public Square — Downtown Cleveland",
  fpcOfficeAddress: "127 Public Square, Cleveland, OH 44114",
  serviceAreaIntro: "From downtown Cleveland to the eastern suburbs of Shaker Heights and Solon, from Lakewood to Mentor on the Lake — Fast Passport Center serves the entire Greater Cleveland area. We regularly help travelers from Parma, Euclid, Westlake, Strongsville, and Akron get their passports fast.",
  nearbyCitiesIntro: "We serve all Cleveland neighborhoods and surrounding Northeast Ohio cities including Lakewood, Parma, Shaker Heights, Euclid, Brook Park, Westlake, North Olmsted, Strongsville, Solon, Mentor, and all the way to Akron. If you are anywhere in Cuyahoga, Lake, Lorain, Medina, or Summit counties, we have you covered.",
  howItWorksIntro: "Most Cleveland travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Cleveland travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Cleveland and Northeast Ohio travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Cleveland? Here are the most common ones we hear from Cuyahoga County travelers.",
  statePageRoute: "/states/ohio",
  statePageName: "Ohio",
  hasPhysicalOffice: true,
  dmvWebsite: "https://www.bmv.ohio.gov",
  dmvLabel: "Ohio BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Cleveland international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Robert P.",
      location: "Cleveland, OH",
      rating: 5,
      text: "Emergency passport needed for a business trip to London. Fast Passport Center came through in under 48 hours. Excellent communication throughout. Highly recommend.",
      service: "Emergency Passport",
    },
    {
      name: "Tanya M.",
      location: "Lakewood, OH",
      rating: 5,
      text: "Renewed my passport for our Italy trip in just 4 days. The process was completely online — no driving, no waiting in government lines. Worth every penny.",
      service: "Passport Renewal",
    },
    {
      name: "Greg S.",
      location: "Parma, OH",
      rating: 5,
      text: "My son needed a first-time passport for a school trip to Canada. They found us the closest acceptance facility and had his passport ready in 5 days. Fantastic service.",
      service: "Child Passport",
    },
    {
      name: "Carla B.",
      location: "Shaker Heights, OH",
      rating: 5,
      text: "Lost my passport at Cleveland Hopkins two hours before a flight. Fast Passport Center stayed on the phone with me, helped file the DS-64, and got a replacement in 36 hours.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "cleveland-1",
      name: "Cleveland Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2400 Orange Ave",
      city: "Cleveland",
      state: "OH",
      zip: "44101",
      phone: "(216) 443-4199",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Near downtown Cleveland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Cleveland facility. Appointments required. Photo services available nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "cleveland-2",
      name: "Lakewood Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16024 Madison Ave",
      city: "Lakewood",
      state: "OH",
      zip: "44107",
      phone: "(216) 529-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West side of Cleveland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for west-side Cleveland and Lakewood residents. Less wait time than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "cleveland-3",
      name: "Euclid Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "25111 Euclid Ave",
      city: "Euclid",
      state: "OH",
      zip: "44117",
      phone: "(216) 261-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East side, near Lake Erie",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves east Cleveland suburbs. Appointment availability typically better than downtown.",
      icon: "ri-mail-line",
    },
    {
      id: "cleveland-4",
      name: "Parma Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5350 State Rd",
      city: "Parma",
      state: "OH",
      zip: "44134",
      phone: "(440) 885-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South suburban Cleveland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Cuyahoga County south suburbs. Good option for Parma, Parma Heights, and Brook Park residents.",
      icon: "ri-mail-line",
    },
    {
      id: "cleveland-5",
      name: "Cuyahoga County Clerk of Courts",
      type: "Court Clerk Passport Acceptance",
      address: "1200 Ontario St",
      city: "Cleveland",
      state: "OH",
      zip: "44113",
      phone: "(216) 443-7950",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Cleveland Justice Center",
      website: "https://cccourts.org/",
      websiteLabel: "Cuyahoga County Courts",
      notes: "Downtown Cleveland location. Convenient for Cuyahoga County residents. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "cleveland-6",
      name: "Mentor Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8600 Civic Center Blvd",
      city: "Mentor",
      state: "OH",
      zip: "44060",
      phone: "(440) 255-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lake County northeast suburb",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lake County. Good option for Mentor, Willoughby, and Eastlake residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — call NPIC, limited slots in Chicago", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — 345 mile drive to Chicago via I-80", fpc: "Most Cleveland travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Cleveland-Specific Guidance", agency: "Generic — no CLE airport, manufacturing, or medical expertise", fpc: "Full Cleveland/Chicago courier/Northeast Ohio knowledge built in" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Cleveland photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Cuyahoga County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Cleveland applicants arrive with incorrect payment and have to reschedule.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Cuyahoga County families.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Cleveland travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Cleveland." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Cleveland address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Cleveland before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Cleveland for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the long drive to Chicago." },
    { q: "How fast can I renew my passport in Cleveland?", a: "Fast Passport Center offers fast passport renewal in Cleveland in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Cleveland?", a: "The nearest regional passport agency to Cleveland is the Chicago Passport Agency, approximately 350 miles away via I-90. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Cleveland without any agency visit required." },
    { q: "Can I get a same-day passport appointment near Cleveland?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Cuyahoga County residents." },
    { q: "Can I expedite a child passport in Cleveland?", a: "Yes. Fast Passport Center expedites child passports in Cleveland for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Downtown Cleveland", address: "1675 E 9th St, Cleveland, OH 44114", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walgreens — Cleveland Heights", address: "2099 S Taylor Rd, Cleveland Heights, OH 44118", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "FedEx Office — Cleveland", address: "1360 E 9th St, Cleveland, OH 44114", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/office/passport-photos.html", websiteLabel: "FedEx Office" },
    { name: "CVS Pharmacy — Lakewood", address: "16916 Detroit Ave, Lakewood, OH 44107", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "Walmart — Parma", address: "7555 W Ridgewood Dr, Parma, OH 44129", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/cp/passport-photos/1055304", websiteLabel: "Walmart Photo" },
    { name: "Walgreens — Westlake", address: "27090 Center Ridge Rd, Westlake, OH 44145", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/photo/passport-photo", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — Mentor", address: "7463 Mentor Ave, Mentor, OH 44060", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/photo/passport-photos", websiteLabel: "CVS Photo" },
    { name: "AAA Travel — Westlake", address: "26050 Center Ridge Rd, Westlake, OH 44145", hours: "Mon–Fri: 8AM–5:30PM", website: "https://www.aaa.com/", websiteLabel: "AAA" },
  ],
  dmvLocations: [
    {
      name: "Cuyahoga County BMV — Cleveland",
      address: "2800 Euclid Ave, Cleveland, OH 44115",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "Cuyahoga County BMV — Parma",
      address: "7781 Broadview Rd, Parma, OH 44134",
      hours: "Mon–Fri: 8AM–5PM",
      note: "South suburban BMV. REAL ID available. Shorter waits than downtown.",
      featured: false,
    },
    {
      name: "Cuyahoga County BMV — Euclid",
      address: "21901 Euclid Ave, Euclid, OH 44117",
      hours: "Mon–Fri: 8AM–5PM",
      note: "East side option. Full licensing services.",
      featured: false,
    },
    {
      name: "Lake County BMV — Mentor",
      address: "7086 Center St, Mentor, OH 44060",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Alternative for Lake County residents. REAL ID and standard renewals.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "CLE",
      name: "Cleveland Hopkins International Airport",
      distance: "11 miles from downtown Cleveland",
      address: "5300 Riverside Dr, Cleveland, OH 44135",
      note: "Primary international airport serving Northeast Ohio. United hub with direct international flights to Europe and beyond.",
      flightUrl: "https://www.clevelandairport.com/",
      flightLabel: "CLE Airport",
      featured: true,
    },
    {
      code: "CAK",
      name: "Akron-Canton Airport",
      distance: "45 miles south of Cleveland",
      address: "5400 Lauby Rd NW, North Canton, OH 44720",
      note: "Alternative airport for south Cleveland suburbs and Summit County travelers. Good domestic connections.",
      flightUrl: "https://www.akroncantonairport.com/",
      flightLabel: "Akron-Canton Airport",
      featured: false,
    },
    {
      code: "BKL",
      name: "Burke Lakefront Airport",
      distance: "3 miles from downtown Cleveland",
      address: "1501 N Marginal Rd, Cleveland, OH 44114",
      note: "General aviation and corporate flights. Very close to downtown. Charter and private flights only.",
      flightUrl: "https://www.clevelandairport.com/burke",
      flightLabel: "Burke Lakefront",
      featured: false,
    },
  ],
};